export default __webpack_public_path__ + "c8720dccaae2e334e99029d24871d158.png";